import StatusBadge from "@ui-application/data-display/badges/StatusBadge/StatusBadge.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { EventRestrictionsProps } from "./EventRestrictions.props";

const EventRestrictions = ({ restrictionArray }: EventRestrictionsProps) => {
  return (
    <Flex display="inline-block">
      {restrictionArray?.map((restriction: string) => (
        <Flex key={restriction} mt="xs" mr="xs" display="inline-block">
          <StatusBadge status="info">{restriction}</StatusBadge>
        </Flex>
      ))}
    </Flex>
  );
};

export default EventRestrictions;
